import { ApiBind, Common } from './common.model';

/**
 * パラメータ項目のバリデーション結果の情報.
 *
 * @exports
 * @extends Common
 */
export class ParameterValidationResult extends Common {
  @ApiBind({ column: 'key' })
  key: string;

  @ApiBind({ column: 'cause' })
  cause: string;
}
